import styled from "styled-components";
import { slideIn } from "../../styles/animations";

export const DropdownsWrapper = styled.div`
  padding: 0 40px;
  margin-bottom: 40px;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 40px 23px;
`;

export const Text = styled.p`
  font-family: "Rubik", sans-serif;
  font-size: 15px;
  font-weight: 400;
  color: #667085;
`;

export const Link = styled.a`
  font-family: "Rubik", sans-serif;
  font-size: 15px;
  font-weight: 400;
  color: #667085;
  text-decoration: underline;
`;

export const InviteBubbleWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
  border-radius: 7px;
  background: rgba(0, 0, 0, 0.34);
  overflow: auto;
  display: flex;
  align-items: flex-end;
`;

export const InviteContent = styled.div`
  ${slideIn("20px")}
  width: 100%;
  height: fit-content;
`;
